import * as React from "react";

function SvgArrowRightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={9}
      height={9}
      {...props}
    >
      <defs>
        <path
          d="M0 4.01h7.33L3.83.5l.62-.61L9 4.44 4.45 9l-.62-.61 3.5-3.51H0v-.87z"
          id="arrowRightIcon_svg__a"
        />
      </defs>
      <use xlinkHref="#arrowRightIcon_svg__a" fill="#3BC8B8" />
      <use
        xlinkHref="#arrowRightIcon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgArrowRightIcon;
